import React from "react";
import {
  Box,
  Typography,
  Button,
  Breadcrumbs,
  // Link,
} from "@mui/material";
import {
  Add as AddIcon,
  // Home as HomeIcon,
  NavigateNext as NavigateNextIcon,
} from "@mui/icons-material";
import UserProfileModal from "../Models/UserProfileModal";
import { colors } from "../../theme/colors";

interface HeaderProps {
  title: string;
  breadcrumb: string;
  isStationsPage?: boolean;
  onAddStation?: () => void;
  isGenerateQrPage?: boolean;
  onCreateQrBatch?: () => void;
  isUserPage?: boolean;
  handleAddUserClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  breadcrumb,
  isStationsPage = false,
  onAddStation,
  isGenerateQrPage = false,
  onCreateQrBatch,
  isUserPage = false,
  handleAddUserClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "15px 32px",
        bgcolor: colors.surface,
        borderBottom: `1px solid ${colors.inputBorderColor}`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            color: colors.darkGreen,
            fontFamily: "'Inter', sans-serif",
            m: 0,
          }}
        >
          {title}
        </Typography>

        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          sx={{ color: colors.black }}
        >
          <Typography
            sx={{
              color: colors.lightGray,
              fontWeight: 500,
              fontSize: "12px",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            {breadcrumb}
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "center",
        }}
      >
        {isStationsPage && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              bgcolor: colors.primary,
              textTransform: "none",
              "&:hover": { bgcolor: colors.primary },
            }}
            onClick={() => onAddStation && onAddStation()}
          >
            Add New Station
          </Button>
        )}
        {isGenerateQrPage && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              bgcolor: colors.primary,
              textTransform: "none",
              "&:hover": { bgcolor: colors.primary },
            }}
            onClick={() => onCreateQrBatch && onCreateQrBatch()}
          >
            Create Batch
          </Button>
        )}
        {isUserPage && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddUserClick}
            sx={{ textTransform: "none", bgcolor: colors.primary }}
          >
            Add User
          </Button>
        )}
        <UserProfileModal />
      </Box>
    </Box>
  );
};
